<template>
  <div>
    <div class="big flex justify-center m-4">
      {{ $t('selectPlaylists') | capitalize }}
    </div>
    <div v-if="usageType === 'duration' && !rule" class="red flex m-4">
      {{ $t('preDistributionWarning') | capitalize }}
    </div>
    <div class="select-playlist-container">
      <!--LEFT: AVAILABLE PLAYLISTS-->
      <div class="left-section">
        <div class="relative">
          <span class="search-icon">
            <i class="far fa-search" />
          </span>
          <input
            v-model="inputValue"
            type="search"
            class="input"
            @input="debounce"
          >
          <span
            class="delete-icon"
            @click="deleteInput"
          >
            <i class="far fa-times" />
          </span>
          <b-button
            size="sm"
            class="mt-3"
            variant="primary"
            @click="addAllPlaylists"
            v-if="!!playlists.length"
          >
            {{ $t("select_all") | capitalize }}
          </b-button>
        </div>
        <div class="results">
          <!-- PLAYLIST FILES -->

          <template>
            <div class="overflow-hidden">
              <b-table
                borderless
                id="playlists-table"
                :items="playlists"
                :fields="fields"
              >
                <template v-slot:cell(title)="data">
                  <span
                    :key="data.item.id"
                    class="w100p"
                  >
                    <div
                      class="playlist table-main-class"
                      @click="addPlaylist(data.item)"
                    >
                      <div
                        v-b-tooltip.hover
                        :title="data.item.processed_url.split('/').pop()"
                        class="name-container"
                      >
                        {{ data.item.processed_url.split('/').pop() }}
                        <div>
                          <span class="table-sub-class text-sm">
                            {{ data.item.upload_date | transformDate("MMMM Do YYYY") }}
                          </span>
                          <span class="table-sub-class text-sm">
                            {{ data.item.upload_date | transformDate("h:mm a") }}
                          </span>
                        </div>
                      </div>
                      <div class="link-class mr-2 show-hover">
                        {{ $t('add') }}
                        <span class="ml-1">
                          <i class="far fa-plus" />
                        </span>
                      </div>
                    </div>
                    <!-- PLAYLIST SHEETS -->
                    <div
                      v-for="sheet in data.item.sheets"
                      :key="sheet.id"
                      class="sheet table-sub-class"
                      @click="addSheet(data.item, sheet)"
                    >
                      <div class="name-container">
                        <i class="fas fa-level-up-alt rotate-90 h-100" />
                        <span>{{ sheet.name }}</span>
                      </div>
                      <div class="link-class mr-2 show-hover">
                        {{ $t('add') }}
                        <span class="ml-1">
                          <i class="far fa-plus" />
                        </span>
                      </div>
                    </div>
                  </span>
                </template>

                <template v-slot:table-caption>
                  <p class="text-nowrap" v-if="!playlists.length">{{ $t('playlist_not_found') }}</p>
                </template>
              </b-table>

              <b-pagination
                v-if="totalCount > perPage"
                v-model="currentPage"
                :total-rows="totalCount"
                :per-page="perPage"
                aria-controls="playlists-table"
              ></b-pagination>
            </div>
          </template>

        </div>
      </div>
      <!--RIGHT: SELECTED PLAYLISTS-->
      <div class="right-section">
        <b-button
          size="sm"
          variant="primary"
          @click="removeAllPlaylists"
          v-if="!!selectedPlaylists.length"
        >
          {{ $t("remove_all") | capitalize }}
        </b-button>
        <div class="results mt-2">
          <!-- PLAYLIST FILES -->
          <span
            v-for="playlist in selectedPlaylists"
            :key="playlist.id"
            class="w100p"
          >
            <div
              class="playlist table-main-class"
              @click="removePlaylist(playlist)"
            >
              <div
                v-b-tooltip.hover
                :title="playlist.processed_url.split('/').pop()"
                class="name-container"
              >
                {{ playlist.processed_url.split('/').pop() }}
                <div>
                  <span class="table-sub-class text-sm">
                    {{ playlist.upload_date | transformDate("MMMM Do YYYY") }}
                  </span>
                  <span class="table-sub-class text-sm">
                    {{ playlist.upload_date | transformDate("h:mm a") }}
                  </span>
                </div>
              </div>
              <div class="link-class mr-2 show-hover">
                {{ $t('remove') }}
                <span class="ml-1">
                  <i class="far fa-times" />
                </span>
              </div>
            </div>
            <!-- PLAYLIST SHEETS -->
            <div
              v-for="sheet in playlist.sheets"
              :key="sheet.id"
              class="sheet table-sub-class"
              @click="removeSheet(playlist, sheet)"
            >
              <div class="name-container">
                <i class="fas fa-level-up-alt rotate-90 h-100" />
                <span>{{ sheet.name }}</span>
              </div>
              <div class="link-class mr-2 show-hover">
                {{ $t('remove') }}
                <span class="ml-1">
                  <i class="far fa-times" />
                </span>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div class="btn-section">
      <span class="white">
        <span
          class="btn add-btn py-2 btn-outline-secondary"
          @click="$emit('close')"
        >
          <span>{{ $t('cancel') | capitalize }}</span>
        </span>
      </span>
      <b-button
        size="lg"
        class="ml-4 px-4 add-btn btn-primary"
        variant="primary"
        @click="save"
      >
        <span>{{ $t('save')|capitalize }}</span>
      </b-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.name-container {
  width: 80%;
  overflow: hidden;
}

.select-playlist-container {
  margin: auto;
  width: 90%;
  height: 350px;
  border-radius: 6px;
  border: solid 1px lightgray;
  display: flex;
}

.left-section {
  overflow-y: auto;
  width: 80%;
  border-right: solid 1px lightgray;
  height: 100%;
  padding: 10px;
}

.right-section {
  overflow-y: auto;
  padding: 10px;
  width: 90%;
}

.btn-section {
  padding: 40px;
  display: flex;
  justify-content: flex-end;
}

.input {
  background-color: rgba(124, 154, 171, 0.2) !important;
  width: 100%;
  height: 33px;
  border: none !important;
  border-radius: 3px;
  padding-left: 38px;
  opacity: 0.7;
}

.search-icon {
  position: absolute;
  top: 7px;
  left: 12px;
}

.delete-icon {
  cursor: pointer;
  z-index: 1000;
  position: absolute;
  top: 7px;
  right: 12px;
}

.results {
  display: flex;
  flex-wrap: wrap;
  // flex-direction: column;
}

.playlist {
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 8px;
  cursor: pointer;
}

.sheet {
  padding-left: 25px;
  min-height: 30px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
}

.fas.fa-level-up-alt {
  width: 15px;
  margin: 0;
  padding: 2px;
  margin-right: 5px;
}

.playlist:hover,
.sheet:hover {
  background-color: rgba(124, 154, 171, 0.2) !important;
}

.show-hover {
  visibility: hidden;
}

.link-class {
  display: flex;
  align-items: center;
  float: right;
  padding-right: 10px;
}

.playlist:hover .show-hover,
.sheet:hover .show-hover {
  visibility: visible !important;
}
</style>

<script>
/* eslint-disable camelcase */
import { clone, cloneDeep } from "lodash"
import { api } from "@/main"
import { mapGetters } from "vuex"

export default {
  name: "PlaylistSelector",

  data () {
    return {
      inputValue: "",
      playlists: [],
      totalCount: 0,
      selectedPlaylists: [],
      timeout: null,
      currentPage: 1,
      perPage: 10,
      headings: [],
      fields: [{
        key: "title",
        thStyle: {
          display: "none"
        }
      }]
    }
  },

  mounted () {
    this.getPlaylists()
    this.selectedPlaylists = this.initial
  },

  methods: {
    addPlaylist (playlist) {
      const index = this.selectedPlaylists.findIndex(item => item.id == playlist.id)
      let _playlist = cloneDeep(playlist)

      if (index == -1) {  // Not in selected playlists
        this.selectedPlaylists.push(_playlist)
      } else {
        this.selectedPlaylists.splice(index, 1, _playlist)
      }
    },
    addAllPlaylists () {
      this.selectedPlaylists = cloneDeep(this.playlists)
    },
    removePlaylist (playlist) {
      const index = this.selectedPlaylists.findIndex(item => item.id == playlist.id)
      this.selectedPlaylists.splice(index, 1)
    },
    removeAllPlaylists () {
      this.selectedPlaylists = []
    },
    addSheet (playlist, sheet) {
      const plIdx = this.selectedPlaylists.findIndex(item => item.id == playlist.id)

      if (plIdx == -1) {  // Not in selected playlists
        let _playlist = cloneDeep(playlist)
        _playlist.sheets = [sheet]
        this.selectedPlaylists.push(_playlist)
      } else {
        const shIdx = this.selectedPlaylists[plIdx].sheets.findIndex(item => item.id == sheet.id)
        let _sheet = clone(sheet)

        if (shIdx == -1) {  // Not in selected playlist's sheets
          this.selectedPlaylists[plIdx].sheets.push(_sheet)
        }
      }
    },
    removeSheet (playlist, sheet) {
      const shIdx = playlist.sheets.findIndex(item => item.id == sheet.id)
      playlist.sheets.splice(shIdx, 1)

      if (playlist.sheets.length == 0) {
        const plIdx = this.selectedPlaylists.findIndex(item => item.id == playlist.id)
        this.selectedPlaylists.splice(plIdx, 1)
      }
    },

    filterSheetsByDuration (obj) {
      const sheets = obj.sheets.filter(sheet => sheet.usage_type === "duration")
      if(sheets.length){
        return {
          ...obj,
          sheets: sheets
        }
      }
    },
    getPlaylists (value="", page=1) {
      let url = `playlistfiles/?fuzzy_search=${value}` +
      "&ordering=-upload_date" +
      `&status=${this.statusTypes.MATCHED}` +
      `&page=${page}` +
      `&page_size=${this.perPage}`
      if(this.rule && this.rule.name === "ipab"){
        this.usageType = "duration"
      }
      url = this.allocableOnly ? url + "&allocable=true" : url
      url = this.usageType ? url + "&type=" + this.usageType : url

      api
        .get(url)
        .then(res => {
          const { get } = this.$options.filters
          const results = get(res, "data.results", [])
          this.playlists = results
          this.totalCount = res.data.count
        })
        .catch(err => {
          this.$toasted.global.toast(err)
        })
    },
    debounce ({ target }) {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getPlaylists(target.value)
      }, 1000)
    },
    deleteInput () {
      this.inputValue = ""
      this.currentPage = 1
      this.getPlaylists()
    },
    save () {
      this.$emit("save", this.selectedPlaylists)
      this.$emit("close")
    },
  },
  computed: {
    ...mapGetters("soundsys", ["statusTypes"]),
  },
  watch: {
    currentPage (value) {
      this.getPlaylists(this.inputValue, value)
    },
    inputValue (value) {
      if (!value) this.currentPage = 1
    },
  },
  props: {
    initial: {
      type: Array[Object],
      default: []
    },
    allocableOnly: {
      type: Boolean,
      default: false
    },
    usageType: {
      type: String,
      default: null
    },
    rule: {
      type: Object,
      default: null
    },
  }
}
</script>
